module.exports = __webpack_public_path__ + "img/skills.59dc4e64.png";